module.exports = __webpack_public_path__ + "static/img/k10.972681d2.png";